document.addEventListener("DOMContentLoaded", function () {
  const statusSelect = document.querySelector("#booking_status");
  const phoneField   = document.querySelector(".field-phone");
  const nameField    = document.querySelector(".field-name");
  const detailFields = document.querySelectorAll(".field-details");

  // Only run if the key elements exist
  if (statusSelect && phoneField && nameField) {
    function toggleFields() {
      const status = statusSelect.value;

      if (status === "reserved") {
        // Reservation: phone + name visible, other details hidden
        phoneField.style.display = "block";
        nameField.style.display  = "block";
        detailFields.forEach(f => f.style.display = "none");
      } else if (status === "checked_in") {
        // Immediate check-in: phone + name + full details visible
        phoneField.style.display = "block";
        nameField.style.display  = "block";
        detailFields.forEach(f => f.style.display = "block");
      } else {
        // Default: show everything
        phoneField.style.display = "block";
        nameField.style.display  = "block";
        detailFields.forEach(f => f.style.display = "block");
      }
    }

    // Run once on page load
    toggleFields();

    // Run whenever status changes
    statusSelect.addEventListener("change", toggleFields);
  }
});
